'use client';

import { Box } from '@chakra-ui/react';
import NextImage from 'next/image';
import { useEffect, useState } from 'react';
const HUBSPOT_CHECK_INTERVAL_MS = 500;
export default function CustomChatButton() {
  const [isHubSpotLoaded, setIsHubSpotLoaded] = useState(false);
  useEffect(() => {
    const checkHubSpot = setInterval(() => {
      if (window.HubSpotConversations) {
        setIsHubSpotLoaded(true);
        clearInterval(checkHubSpot);
      }
    }, HUBSPOT_CHECK_INTERVAL_MS);
    return () => clearInterval(checkHubSpot);
  }, []);
  const handleOpenChat = () => {
    window.HubSpotConversations?.widget.open();
  };
  if (!isHubSpotLoaded) {
    return null;
  }
  return <Box as="button" position="fixed" bottom={5} right={5} width={15} height={15} borderRadius="50%" cursor="pointer" zIndex="var(--ss-z-index-overlay)" border="none" padding="0" backgroundColor="transparent" onClick={handleOpenChat} _hover={{
    transform: 'scale(1.05)'
  }} transition="transform 0.2s" aria-label="Open chat" overflow="hidden" data-sentry-element="Box" data-sentry-component="CustomChatButton" data-sentry-source-file="CustomChatButton.tsx">
      <NextImage src="/chatbot.png" alt="Chat with us" width={15} height={15} priority data-sentry-element="NextImage" data-sentry-source-file="CustomChatButton.tsx" />
    </Box>;
}